module.exports = __webpack_public_path__ + "static/media/user.5796fbf8.png";